import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeStore {
  isDark: boolean;
  toggleTheme: () => void;
  setTheme: (isDark: boolean) => void;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      isDark: true, // Forzar dark mode

      toggleTheme: () => {
        // Deshabilitado - siempre en dark mode
        set({ isDark: true });
        document.documentElement.classList.add('dark');
        document.body.classList.add('dark');
      },

      setTheme: (isDark: boolean) => {
        // Forzar dark mode siempre
        set({ isDark: true });
        document.documentElement.classList.add('dark');
        document.body.classList.add('dark');
      },
    }),
    {
      name: 'theme-storage',
    }
  )
);